<template>
  <div class="select-audio container align-center" :class="{ right: answered && correct, wrong: answered && !correct}">
    <div class="index" @click="select()">{{ index + 1 }}</div>
    <div class="checkbox" @click="select()">
      <img src="@/assets/img/icons/check.svg" width="25" alt="Right" class v-show="answered && correct">
      <img src="@/assets/img/icons/cancel.svg" width="25" alt="wrong" class v-show="answered && !correct">
    </div>
    <div class="player container align-center">
      <audio
        ref="player"
        :src="src"
        @playing="playing = true"
        @pause="playing = false"
        @loadeddata="loaded($event.target)"
        @timeupdate="timeChanged($event.target.currentTime)"
        @ended="ended = true"
        hidden
      />
      <div class="player-controls container align-center">
        <button
          class="player-control"
          @click="toogle()"
          :class="{'player-controls-play' : playing, 'player-controls-pause' : !playing}"
        >
          <span v-if="playing">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <defs>
                <clipPath id="b">
                  <rect width="30" height="30"></rect>
                </clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <g transform="translate(-363 -420)">
                  <path
                    d="M7.5,2.017a14.994,14.994,0,0,1,21.98,16.866A15.012,15.012,0,0,1,15.024,30a15.09,15.09,0,0,1-3.905-.517A14.994,14.994,0,0,1,7.5,2.017ZM27.975,18.478a13.432,13.432,0,0,0-9.5-16.451,13.512,13.512,0,0,0-3.5-.463A13.437,13.437,0,0,0,3.367,21.718a13.432,13.432,0,0,0,24.607-3.24Z"
                    transform="translate(363 419.998)"
                    fill="#003944"
                  ></path>
                  <path
                    d="M51.729,33.388a13.418,13.418,0,1,1-11.655-6.721,13.514,13.514,0,0,1,3.5.463A13.346,13.346,0,0,1,51.729,33.388Zm-2.555.689a.781.781,0,0,0,.14-1.1,11.774,11.774,0,0,0-7.658-4.422.781.781,0,0,0-.212,1.547,10.2,10.2,0,0,1,6.635,3.83.781.781,0,0,0,1.1.14Z"
                    transform="translate(337.904 394.895)"
                    fill="#afd6de"
                  ></path>
                  <g transform="translate(373.103 423.448)">
                    <path
                      d="M276.024,63.283a.781.781,0,0,1-1.235.956,10.2,10.2,0,0,0-6.635-3.83.781.781,0,0,1,.212-1.547A11.774,11.774,0,0,1,276.024,63.283Z"
                      transform="translate(-261.91 -58.854)"
                      fill="#003944"
                    ></path>
                  </g>
                  <g transform="translate(0.155)">
                    <g transform="translate(362.999 420)">
                      <g transform="translate(9.118 10.117)">
                        <path
                          d="M159.537,156h-2.912a.571.571,0,0,0-.624.488v8.789a.571.571,0,0,0,.624.488h2.912a.571.571,0,0,0,.624-.488v-8.789A.571.571,0,0,0,159.537,156Z"
                          transform="translate(-156.001 -156.001)"
                          fill="#5de4ff"
                        ></path>
                      </g>
                      <g transform="translate(8.846 9.629)">
                        <path
                          d="M149.669,146H147.1a1.045,1.045,0,0,0-1.1.977v8.789a1.045,1.045,0,0,0,1.1.977h2.568a1.045,1.045,0,0,0,1.1-.977v-8.789A1.045,1.045,0,0,0,149.669,146Zm-2.568,9.766v-8.789h2.568v8.789Z"
                          transform="translate(-146.001 -146.001)"
                          fill="#003944"
                        ></path>
                      </g>
                    </g>
                    <g transform="translate(370.999 420)">
                      <g transform="translate(9.118 10.117)">
                        <path
                          d="M159.537,156h-2.912a.571.571,0,0,0-.624.488v8.789a.571.571,0,0,0,.624.488h2.912a.571.571,0,0,0,.624-.488v-8.789A.571.571,0,0,0,159.537,156Z"
                          transform="translate(-156.001 -156.001)"
                          fill="#5de4ff"
                        ></path>
                      </g>
                      <g transform="translate(8.846 9.629)">
                        <path
                          d="M149.669,146H147.1a1.045,1.045,0,0,0-1.1.977v8.789a1.045,1.045,0,0,0,1.1.977h2.568a1.045,1.045,0,0,0,1.1-.977v-8.789A1.045,1.045,0,0,0,149.669,146Zm-2.568,9.766v-8.789h2.568v8.789Z"
                          transform="translate(-146.001 -146.001)"
                          fill="#003944"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span v-else>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <defs>
                <clipPath id="b">
                  <rect width="30" height="30"></rect>
                </clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <g transform="translate(-363 -420)">
                  <path
                    d="M7.5,2.017a14.994,14.994,0,0,1,21.98,16.866A15.012,15.012,0,0,1,15.024,30a15.09,15.09,0,0,1-3.905-.517A14.994,14.994,0,0,1,7.5,2.017ZM27.975,18.478a13.432,13.432,0,0,0-9.5-16.451,13.512,13.512,0,0,0-3.5-.463A13.437,13.437,0,0,0,3.367,21.718a13.432,13.432,0,0,0,24.607-3.24Z"
                    transform="translate(363 419.998)"
                    fill="#6200e5"
                  ></path>
                  <path
                    d="M51.729,33.388a13.418,13.418,0,1,1-11.655-6.721,13.514,13.514,0,0,1,3.5.463A13.346,13.346,0,0,1,51.729,33.388Zm-2.555.689a.781.781,0,0,0,.14-1.1,11.774,11.774,0,0,0-7.658-4.422.781.781,0,0,0-.212,1.547,10.2,10.2,0,0,1,6.635,3.83.781.781,0,0,0,1.1.14ZM48.107,40.1a1.616,1.616,0,0,0-.817-1.415l-9.64-5.566A1.634,1.634,0,0,0,35.2,34.539V45.67a1.632,1.632,0,0,0,2.451,1.415l9.64-5.566A1.616,1.616,0,0,0,48.107,40.1Z"
                    transform="translate(337.904 394.895)"
                    fill="#9b8ccc"
                  ></path>
                  <g transform="translate(373.103 423.448)">
                    <path
                      d="M276.024,63.283a.781.781,0,0,1-1.235.956,10.2,10.2,0,0,0-6.635-3.83.781.781,0,0,1,.212-1.547A11.774,11.774,0,0,1,276.024,63.283Z"
                      transform="translate(-261.91 -58.854)"
                      fill="#6200e5"
                    ></path>
                    <path
                      d="M184.511,138.867a1.634,1.634,0,0,1,0,2.829l-9.64,5.566a1.634,1.634,0,0,1-2.451-1.415V134.716a1.634,1.634,0,0,1,2.451-1.415Zm-.745,1.415a.063.063,0,0,0-.036-.062l-9.64-5.566a.075.075,0,0,0-.036-.011.076.076,0,0,0-.037.011.065.065,0,0,0-.037.063v11.131a.065.065,0,0,0,.037.063.068.068,0,0,0,.073,0l9.64-5.567A.063.063,0,0,0,183.766,140.282Z"
                      transform="translate(-172.419 -128.73)"
                      fill="#6200e5"
                    ></path>
                  </g>
                  <path
                    d="M208.816,165.325a.072.072,0,0,1,0,.125l-9.64,5.566a.068.068,0,0,1-.073,0,.065.065,0,0,1-.037-.063V159.822a.065.065,0,0,1,.037-.063.077.077,0,0,1,.037-.011.075.075,0,0,1,.036.011Z"
                    transform="translate(175.597 269.612)"
                    fill="#ffb300"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
        </button>
        <button class="player-control player-controls-restart" @click="reset()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <defs>
              <clipPath id="b">
                <rect width="25" height="25"></rect>
              </clipPath>
            </defs>
            <g id="a" clip-path="url(#b)">
              <g transform="translate(-264 -553)">
                <g transform="translate(264 553)">
                  <g transform="translate(0.68 0.68)">
                    <path
                      d="M11.661,21.672A10.011,10.011,0,1,1,21.672,31.683,10.011,10.011,0,0,1,11.661,21.672ZM21.672,10A11.672,11.672,0,1,0,33.344,21.672,11.672,11.672,0,0,0,21.672,10Z"
                      transform="translate(-10 -10)"
                      fill="#f80"
                    ></path>
                    <circle
                      cx="10.203"
                      cy="10.203"
                      r="10.203"
                      transform="translate(1.469 1.469)"
                      fill="#fff"
                    ></circle>
                  </g>
                </g>
                <path
                  d="M12.5,0A12.5,12.5,0,1,0,25,12.5,12.514,12.514,0,0,0,12.5,0Zm0,24.024A11.523,11.523,0,1,1,24.024,12.5,11.537,11.537,0,0,1,12.5,24.024Z"
                  transform="translate(263.999 553)"
                  fill="#8e4200"
                ></path>
                <path
                  d="M45.792,35A10.791,10.791,0,1,0,56.583,45.791,10.8,10.8,0,0,0,45.792,35Zm0,20.606a9.815,9.815,0,1,1,9.815-9.815A9.826,9.826,0,0,1,45.792,55.606Z"
                  transform="translate(230.708 519.709)"
                  fill="#8e4200"
                ></path>
                <g transform="translate(267.95 515.323)">
                  <path
                    d="M133.545,175.641l-2.752,2.752h1.532a4.454,4.454,0,0,1-7.217,3.5l-1.778,1.779a6.958,6.958,0,0,0,11.5-5.274H136.3Z"
                    transform="translate(-119.106 -128.289)"
                    fill="#f80"
                  ></path>
                  <path
                    d="M118.212,176.036a7.289,7.289,0,0,1-4.763-1.767.342.342,0,0,1-.018-.5l1.778-1.778a.342.342,0,0,1,.455-.026,4.068,4.068,0,0,0,2.548.887,4.12,4.12,0,0,0,4.1-3.771h-1.176a.342.342,0,0,1-.242-.585l2.752-2.752a.342.342,0,0,1,.484,0l2.752,2.752a.342.342,0,0,1-.242.585H125.5a7.3,7.3,0,0,1-7.293,6.958Zm-4.029-2.052a6.616,6.616,0,0,0,10.645-5.248.342.342,0,0,1,.342-.342h.643l-1.925-1.925-1.925,1.925h.706a.342.342,0,0,1,.342.342,4.8,4.8,0,0,1-4.8,4.8,4.739,4.739,0,0,1-2.728-.852Z"
                    transform="translate(-109.449 -118.632)"
                    fill="#8e4200"
                  ></path>
                  <path
                    d="M18.428,52.8a6.958,6.958,0,0,0-6.958,6.958H10l2.752,2.752L15.5,59.762H13.971a4.454,4.454,0,0,1,7.217-3.5l1.778-1.778A6.907,6.907,0,0,0,18.428,52.8Z"
                    transform="translate(-9.657 -9.659)"
                    fill="#f80"
                  ></path>
                  <path
                    d="M3.095,53.2a.341.341,0,0,1-.242-.1L.1,50.346a.342.342,0,0,1,.242-.585H1.478a7.248,7.248,0,0,1,2.13-4.82,7.409,7.409,0,0,1,.942-.8.342.342,0,0,1,.4.558,6.72,6.72,0,0,0-.855.723A6.572,6.572,0,0,0,2.155,50.1a.342.342,0,0,1-.342.342H1.17l1.925,1.925L5.02,50.446H4.314a.342.342,0,0,1-.342-.342,4.8,4.8,0,0,1,4.8-4.8,4.739,4.739,0,0,1,2.728.852l1.3-1.3A6.608,6.608,0,0,0,8.77,43.488a6.692,6.692,0,0,0-1.452.159.342.342,0,1,1-.149-.668,7.375,7.375,0,0,1,1.6-.175,7.289,7.289,0,0,1,4.763,1.767.342.342,0,0,1,.018.5L11.773,46.85a.342.342,0,0,1-.455.026A4.068,4.068,0,0,0,8.77,45.99a4.12,4.12,0,0,0-4.1,3.771H5.846a.342.342,0,0,1,.242.585L3.337,53.1A.342.342,0,0,1,3.095,53.2Z"
                    transform="translate(0 0)"
                    fill="#8e4200"
                  ></path>
                  <path
                    d="M165.068,60.047a.342.342,0,0,1-.137-.656l.029-.013a.342.342,0,0,1,.27.629l-.025.011A.342.342,0,0,1,165.068,60.047Z"
                    transform="translate(-159.084 -15.981)"
                    fill="#8e4200"
                  ></path>
                  <path
                    d="M361.192,371.488a.342.342,0,0,1-.241-.585l.01-.01a.342.342,0,1,1,.484.484l-.011.011A.341.341,0,0,1,361.192,371.488Z"
                    transform="translate(-348.493 -316.759)"
                    fill="#8e4200"
                  ></path>
                  <path
                    d="M247.811,393.806a.342.342,0,0,1,0-.685,5.134,5.134,0,0,0,2.8-.823.342.342,0,1,1,.373.575A5.817,5.817,0,0,1,247.811,393.806Z"
                    transform="translate(-238.994 -337.474)"
                    fill="#8e4200"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <div class="player-progress">
        <div class="player-progress-bg">
          <div
            class="player-progress-current"
            :style="{ width: `${progress}%`, animationName: ended ? 'none' : 'progressAudio', animationDuration: `${duration}s`, animationPlayState: playing ? 'running' : 'paused' }"
          ></div>
        </div>
      </div>
      <div class="player-time">
        <span>{{minutes}}:{{seconds}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "audio-player",
  data() {
    return {
      playing: false,
      canplay: false,
      duration: 0,
      currentTime: 0,
      ended: false,
      clicked: false,
      reseting: false
    };
  },
  props: {
    src: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    beforePlay: {
      type: Function,
      default: () => new Promise(resolve => resolve())
    },
    answered: {
      type: Boolean,
      default: false
    },
    correct: {
      type: Boolean,
      default: false
    },
    select: {
      type: Function,
      default: () => new Promise(resolve => resolve())
    }
  },
  computed: {
    progress() {
      if (!this.canplay) return 0
      if (this.ended) return 100
      const percent = ((this.currentTime) * 100) / this.duration
      return percent > 100 ? 100 : percent
    },
    minutes() {
      if (!this.duration) return 0;
      const minutes = parseInt((this.duration - this.currentTime) / 60, 10);
      return minutes > 9 ? minutes : `0${!minutes ? 0 : minutes}`;
    },
    seconds() {
      if (!this.duration) return 0;
      const seconds = parseInt((this.duration - this.currentTime) % 60);
      return seconds > 9 ? seconds : `0${!seconds ? 0 : seconds}`;
    }
  },
  methods: {
    async play() {
      if (!this.clicked && !this.reseting) {
        if (this.canplay) {
          if (!this.playing) {
            await this.beforePlay()
            this.$refs["player"].play();
          }
        }
      }
    },
    pause() {
      if (!this.clicked && !this.reseting) {
        if (this.canplay) {
          if (this.playing) {
            this.$refs["player"].pause();
          }
        }
      }
    },
    async toogle() {
      if (!this.clicked && !this.reseting) {
        if (this.ended) {
          this.$refs["player"].currentTime = 0;
          await this.$delay(300);
          this.ended = false;
        }
        if (this.canplay) {
          if (this.playing) {
            this.$refs["player"].pause();
          } else {
            await this.beforePlay()
            this.$refs["player"].play();
          }
        }
      }
    },
    async reset() {
      if (!this.reseting && !this.clicked) {
        this.ended = true;
        this.$refs["player"].pause();
        await this.$delay(10);
        this.$refs["player"].currentTime = 0;
        await this.$delay(300);
        this.ended = false;
        await this.beforePlay()
        this.$refs["player"].play();
      }
    },
    loaded(audio) {
      this.duration = audio.duration;
      this.canplay = true;
      this.setInitialValues()
    },
    timeChanged(time) {
      this.currentTime = time;
    },
    setInitialValues () {
      this.$refs["player"].pause();
      this.playing = false
      this.$refs["player"].currentTime = 0;
      this.currentTime = 0;
    }
  },
  watch: {
    src() {
      this.setInitialValues()
      this.canplay = false;
      this.duration = 0;
      this.$refs["player"].load();
    }
  },
  mounted() {
    this.$refs["player"].load();
    this.setInitialValues()
  }
};
</script>


<style lang="scss" scoped>
@import "./src/assets/css/base/variables";
.select-audio {
  background: #d8d8d8;
  border-radius: 50px;
  .index,
  .checkbox {
    border: 1px solid #979797;
    background: #afafaf;
    color: #fff;
    width: 30px;
    min-width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin: 0 10px;
    box-sizing: border-box;
  }

  .checkbox {
    border: 3px solid #b7b7b7;
    background: #fff;
    margin-left: 0;
    cursor: pointer;
    &:hover {
      color: #f4f4f4;
    }
  }

  &.right {
    background: #dffb6c;
    .index {
      border: 1px solid #79940d;
      background: #abc92e;
      color: #7e9a10;
    }
    .checkbox {
      border-color: #7e9a10;
    }
  }

  &.wrong {
    background: lighten($color-red, 10);
    .index {
      border: 1px solid #d62727;
      background: #eb8787;
      color: #9c0404;
    }
    .checkbox {
      border-color: #d62727;
    }
  }
  .player {
    background: $color-blue-dark;
    padding: 8px;
    border-radius: 50px;
    padding: 8px;
    width: 100%;
    flex-grow: 1;
  }
}

.player-control {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  border: none;
  transition: 0.3s;
  margin-right: 8px;
  background: transparent;
  &:hover {
    transform: scale(1.1, 1.1);
  }

  &.player-controls-restart {
    width: 25px;
    height: 25px;
  }

  &:active {
    background: #2b0872;
  }
}

.player-time {
  width: 55px;
  text-align: right;
  padding-right: 8px;
  span {
    font-size: 14px;
    color: #fff;
  }
}
.player-progress {
  flex-grow: 1;
}
.player-progress-bg {
  height: 10px;
  border-radius: 20px;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  overflow: hidden;
}

.player-progress-current {
  transition: width 0.2s;
  background: #510cd8;
  height: 10px;
  border-radius: 20px;
  animation-timing-function: linear;
  animation-fill-mode: backwards;
}

@keyframes progressAudio {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/GameComponents/audio-player-select-audio.vue